import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Breadcrumbs.module.css";

const Breadcrumbs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);

  if (location.pathname === "/") return null;

  return (
    <div className={styles.breadcrumbs}>
      <span
        className={`${styles.breadcrumb} ${
          pathnames.length === 0 ? styles.active : ""
        }`}
        onClick={() => navigate("/")}
      >
        home
      </span>
      {pathnames.map((name, index) => {
        const routeTo = "/" + pathnames.slice(0, index + 1).join("/");
        const isActive = index === pathnames.length - 1;
        return (
          <span key={name}>
            {" / "}
            <span
              className={`${styles.breadcrumb} ${
                isActive ? styles.active : ""
              }`}
              onClick={() => navigate(routeTo)}
            >
              {name.toLowerCase()}
            </span>
          </span>
        );
      })}
    </div>
  );
};

export default Breadcrumbs;
